module.exports = __webpack_public_path__ + "static/media/patternStaticPage.45b70e57.png";